// Shared mapper functions used by trashActions.js (trash bin page) and archiveActions.js (matter Archive + Trash tab)

function getReplacementValuesForUrls(item) {
	let valueToReplace = "";
	let replaceValueWith = "";
	if (item.type === "Email") {
		valueToReplace = "/email";
		replaceValueWith = "Email";
	}
	if (item.type === "Note") {
		valueToReplace = "/notes";
		replaceValueWith = "Notes";
	}
	if (item.type === "File") {
		valueToReplace = "/docs";
		replaceValueWith = "Documents";
	}
	return { valueToReplace, replaceValueWith };
}

export function getFolderPathAndLocationLink(item) {
	let folderPath =
		item.folderPath + `${item.folderID ? "" : item.folderName + "/"}`;
	// API basepath of the directory containing the item, e.g. "docs/Folder A/"
	const apiBasepath = folderPath.slice(1);
	let displayFolderPath = "DEFAULT VALUE";
	let matterName = item.matterName;

	let { valueToReplace, replaceValueWith } =
		getReplacementValuesForUrls(item);

	if (folderPath.startsWith("/public")) {
		folderPath = folderPath.replace("/public", "/firmDocs/public/docs");
		displayFolderPath = folderPath.replace(
			"/firmDocs/public/docs/",
			"Public Firm Docs/"
		);
		matterName = "Public Firm Documents";
	} else if (folderPath.startsWith("/private")) {
		folderPath = folderPath.replace("/private", "/firmDocs/private/docs");
		displayFolderPath = folderPath.replace(
			"/firmDocs/private/docs/",
			"Private Firm Docs/"
		);
		matterName = "Private Firm Documents";
	} else {
		folderPath = folderPath.replace(
			valueToReplace,
			"/matters/" + item.matterID + valueToReplace
		);
		displayFolderPath = folderPath.replace(
			"/matters/" + item.matterID + valueToReplace,
			replaceValueWith
		);
	}

	return {
		displayFolderPath,
		folderPath,
		apiBasepath,
		matterName,
	};
}

export function documentMap(documents) {
	return documents.map((item) => {
		let { folderPath, displayFolderPath, apiBasepath, matterName } =
			getFolderPathAndLocationLink({ ...item, type: "File" });

		return {
			type: "File",
			matterName,
			id: item.documentID,
			matterID: item.matterID,
			filename: item.filename,
			folderPath,
			displayFolderPath,
			apiBasepath,
			clientName: item.clientName,
			lifecycleStatus: item.lifecycleStatus,
		};
	});
}

export function emailMap(emails) {
	return emails.map((item) => {
		let { folderPath, displayFolderPath, apiBasepath, matterName } =
			getFolderPathAndLocationLink({ ...item, type: "Email" });

		return {
			type: "Email",
			matterName,
			id: item.emailID,
			matterID: item.matterID,
			filename: item.subjectline,
			folderPath,
			displayFolderPath,
			apiBasepath,
			clientName: item.clientName,
			lifecycleStatus: item.lifecycleStatus,
		};
	});
}

export function notesMap(notes) {
	return notes.map((item) => {
		let { folderPath, displayFolderPath, apiBasepath, matterName } =
			getFolderPathAndLocationLink({ ...item, type: "Note" });
		return {
			type: "Note",
			matterName,
			id: item.noteID,
			matterID: item.matterID,
			filename: item.name,
			folderPath,
			displayFolderPath,
			apiBasepath,
			clientName: item.clientName,
			lifecycleStatus: item.lifecycleStatus,
		};
	});
}

export function directoryMap(directories, objectType) {
	return directories.map((item) => {
		let { folderPath, displayFolderPath, apiBasepath, matterName } =
			getFolderPathAndLocationLink({ ...item, type: objectType });
		return {
			type: "Folder",
			id: item.folderID,
			filename: item.folderName,
			matterName,
			matterID: item.matterID,
			folderPath,
			displayFolderPath,
			apiBasepath,
			clientName: item.clientName,
			lifecycleStatus: item.lifecycleStatus,
		};
	});
}
